import { useEffect, useState } from "react";
import { CalendarCheck, RefreshCw, CreditCard } from "lucide-react";
import api from "../lib/api";
import { useI18n } from "../lib/i18n";

const L = {
  it: { notice: "Dal {d} le generazioni di immagini e video useranno più crediti (vedi sempre il costo prima di generare). Il prezzo del piano non cambia{pro}.", pro: "; il piano Pro passa a 300 crediti al mese dal primo rinnovo dopo quella data", since: "Iscritto dal", refill: "Prossima ricarica crediti", renew: "Prossimo rinnovo", ends: "Il piano termina il", yearly: "piano annuale · crediti ricaricati ogni mese" },
  en: { notice: "From {d} image and video generations will use more credits (you always see the cost before generating). Your plan price does not change{pro}.", pro: "; the Pro plan moves to 300 monthly credits from your first renewal after that date", since: "Subscribed since", refill: "Next credit refill", renew: "Next renewal", ends: "Plan ends on", yearly: "yearly plan · credits refilled every month" },
  es: { since: "Suscrito desde", refill: "Próxima recarga de créditos", renew: "Próxima renovación", ends: "El plan termina el", yearly: "plan anual · créditos recargados cada mes" },
  fr: { since: "Abonné depuis", refill: "Prochaine recharge de crédits", renew: "Prochain renouvellement", ends: "Le forfait se termine le", yearly: "forfait annuel · crédits rechargés chaque mois" },
  de: { since: "Abonniert seit", refill: "Nächste Credit-Aufladung", renew: "Nächste Verlängerung", ends: "Plan endet am", yearly: "Jahresplan · Credits werden monatlich aufgeladen" },
};

export function BillingDates() {
  const { lang } = useI18n();
  const tt = L[lang] || L.en;
  const [d, setD] = useState(null);
  const [notice, setNotice] = useState(null);
  useEffect(() => {
    api.get("/payments/billing-dates").then((r) => setD(r.data)).catch(() => {});
    api.get("/payments/pricing-notice").then((r) => setNotice(r.data)).catch(() => {});
  }, []);
  if (!d || !d.plan || d.plan === "pending") return null;
  const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString(lang, { day: "numeric", month: "long", year: "numeric" }) : "—");
  const items = [
    { Icon: CalendarCheck, label: tt.since, value: fmt(d.subscribed_at), id: "since" },
    { Icon: RefreshCw, label: tt.refill, value: fmt(d.next_credit_reset), id: "refill" },
    { Icon: CreditCard, label: d.cancel_at_period_end ? tt.ends : tt.renew, value: fmt(d.next_renewal), id: "renewal",
      note: d.billing === "yearly" ? tt.yearly : null },
  ].filter((it) => it.id === "refill" || it.value !== "—");
  const nt = L[lang]?.notice ? L[lang] : L.en;
  return (
    <>
    {notice && !notice.active && (
      <div className="mb-4 rounded-md border border-orange-500/30 bg-orange-500/[0.06] p-4 text-sm text-zinc-300" data-testid="pricing-notice">
        {nt.notice.replace("{d}", fmt(notice.from)).replace("{pro}", d.plan === "pro" ? nt.pro : "")}
      </div>
    )}
    <div className="mb-10 grid sm:grid-cols-3 gap-3 sm:[&>*:only-child]:col-span-1" data-testid="billing-dates">
      {items.map(({ Icon, label, value, id, note }) => (
        <div key={id} className="rounded-md border border-white/10 bg-white/[0.02] p-4" data-testid={`billing-date-${id}`}>
          <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-zinc-500 font-bold mb-1.5">
            <Icon className="w-3.5 h-3.5 text-orange-400" /> {label}
          </div>
          <div className="text-lg font-black text-white">{value}</div>
          {note && <div className="text-[11px] text-zinc-500 mt-0.5">{note}</div>}
        </div>
      ))}
    </div>
    </>
  );
}
